import type { DomainAssigneesResponse } from '../../types/permissions.types'

export const mockDomainAssigneesResponse: DomainAssigneesResponse = [
  {
    type: 'account',
    id: 'account-1',
    email: 'jane.doe@example.com',
    fullName: 'Jane Doe',
    role: 'admin',
  },
  {
    type: 'account',
    id: 'account-1',
    email: 'jane.doe@example.com',
    fullName: 'Jane Doe',
    role: 'reader',
  },
  {
    type: 'account',
    id: 'account-2',
    email: 'john.smith@example.com',
    role: 'reader',
  },
  {
    type: 'group',
    id: 'group-1',
    name: 'Finance Team',
    role: 'manager',
  },
]
